import styled from 'styled-components';

/* eslint-disable import/prefer-default-export */

export const Frame = styled.iframe`
  width: 100%;
  height: 100%;
`;
